module.exports = __webpack_public_path__ + "static/media/track-suites-for-keyboard.a7988fab.png";